import { Injectable } from '@angular/core';
import { Observable, map, switchMap } from 'rxjs';
import { PreviewService } from './preview.service';
import { AccessService } from '@access/access.service';
import { UserService } from '@shared/modules/account/services/user.service';

@Injectable({
  providedIn: 'root',
})
export class PreviewSessionService {
  constructor(
    private readonly previewService: PreviewService,
    private readonly accessService: AccessService,
    private readonly userService: UserService
  ) {}

  start(userId: string, organizationId: string): Observable<void> {
    return this.previewService.start(userId, organizationId).pipe(
      switchMap(() => this.accessService.reload()),
      map(() => void 0)
    );
  }

  stop(): Observable<void> {
    this.previewService.stop();

    return this.accessService.reload().pipe(map(() => void 0));
  }

  isActive(): boolean {
    return this.previewService.isActive();
  }

  get active$(): Observable<boolean> {
    return this.previewService.active$;
  }

  getToken(): string | null {
    return this.previewService.getToken();
  }

  getExpiresAt(): number | null {
    return this.previewService.getExpiresAt();
  }

  getRemainingTime(): number {
    return this.previewService.getRemainingTime();
  }

  getViewedUserEmail() {
    return this.userService.user?.email;
  }
}
